exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.mt64[data-v-65ecd1bd] {\n    margin-top: 64px;\n}\n", ""]);
